import React from "react";
import Skeleton from "react-loading-skeleton";
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";

const SkeletonForStatusMonitor = () => {
    return (
        <React.Fragment>
            <Row className="d-flex justify-content-center">
                <Col md={10}>
                    <Card>
                        <CardBody>
                            <CardHeader className="d-flex justify-content-between">
                                <CardTitle><Skeleton/></CardTitle>
                                <Skeleton/>
                            </CardHeader>
                            <div className="status-container p-3">
                                <Skeleton />
                                <Skeleton />
                            </div>
                            <Skeleton />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default SkeletonForStatusMonitor